import { ProgressLayout } from 'ipro-ui-kit-vuejs/src/layouts';
import { mapGetters } from 'vuex';

import { LogoutService } from '@/core/logout';
import { ContainerMixin } from '@/core/mixins';
import { OneTimePassRoutesMixin } from '@/portal/one-time-pass/mixins';

import HelpCentre from '@/portal/help-centre/HelpCentre.vue';
import FeedbackPopup from '@/portal/feedback-popup/FeedbackPopup.vue';

// @vue/component
export default {
  components: {
    ProgressLayout,
    HelpCentre,
    FeedbackPopup,
  },
  mixins: [
    ContainerMixin,
    OneTimePassRoutesMixin,
  ],
  data() {
    return {
      progress: 0,
      showingFeedback: false,
    };
  },
  computed: {
    ...mapGetters(['userFullName']),
    ...mapGetters('oneTimePass', ['flattenedAssessmentFields', 'workerInductions']),
    showBottomAdditionalToolbar() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  watch: {
    $route: {
      handler() {
        this.updateProgress();
      },
      immediate: true,
    },
  },
  methods: {
    logout: LogoutService.logout,
    updateProgress() {
      const { routes } = this;
      const steps = [
        routes.welcome,
        routes.assessment,
        routes.criteriaSummary,
        routes.induction,
        routes.reviewApplication,
        routes.success,
      ];

      const currentRouteName = this.$route.name;
      const currentStep = steps.findIndex(route => route.name === currentRouteName);

      const progressPerStep = 100 / (steps.length - 1);
      let partialStepProgress = 0;
      if ([routes.assessment.name, routes.induction.name].includes(currentRouteName)) {
        const onAssessmentPage = currentRouteName === routes.assessment.name;
        const uuidParam = onAssessmentPage ? 'assessmentFieldUuid' : 'inductionUuid';
        const allFields = onAssessmentPage ? this.flattenedAssessmentFields : this.workerInductions;

        const fieldUuid = _.get(this.$route, `params.${uuidParam}`);
        const fieldIndex = allFields.findIndex(field => field.uuid === fieldUuid);
        const fieldsPassed = Math.max(0, fieldIndex);
        partialStepProgress = (fieldsPassed / (allFields.length || 1)) * progressPerStep;
      }
      this.progress = currentStep * progressPerStep + partialStepProgress;
    },
    showFeedback() {
      this.showingFeedback = true;
    },
  },
};
